import { useState } from "react";
import {
  Form,
  Input,
  Card,
  Button,
  Select,
  Typography,
  Space,
  Row,
  Col,
  Tooltip,
  DatePicker,
} from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";

const { Title, Paragraph } = Typography;
const { Option } = Select;

const ComplianceChecks = ({
  formData,
  form,
  onFinish,
  updateFormData,
  kycStatusOptions,
  amlScreeningOptions,
  sanctionScreeningOptions,
  centralBankReportOptions,
}) => {
  const handleValuesChange = (changedValues, allValues) => {
    updateFormData(allValues);
  };

  const handleFinish = (_data) => {
    onFinish(_data);
  };

  return (
    <div className="form-section">
      <h2 style={{ margin: 0, fontSize: "24px", marginBottom: "24px" }}>
        Compliance Checks
      </h2>

      <Form
        form={form}
        layout="vertical"
        initialValues={formData}
        onFinish={handleFinish}
        onValuesChange={handleValuesChange}
        style={{ width: "100%" }}
      >
        <Row>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <Space>
                  Know Your Customer(KYC) Status
                  <Tooltip title="Know Your Customer(KYC) Status">
                    <InfoCircleOutlined />
                  </Tooltip>
                </Space>
              }
              name={"kycStatus"}
              rules={[
                {
                  required: true,
                  message: "Please select KYC status",
                },
              ]}
            >
              <Select
                placeholder="Select KYC Status"
                optionFilterProp="children"
                style={{ height: "44px" }}
                options={kycStatusOptions}
              />
            </Form.Item>
          </Col>

          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <Space>
                  Anti-Money Laundering (AML) Screening
                  <Tooltip title="Anti-Money Laundering (AML) Screening">
                    <InfoCircleOutlined />
                  </Tooltip>
                </Space>
              }
              name={"amlScreening"}
              rules={[
                {
                  required: true,
                  message: "Please select AML screening status",
                },
              ]}
            >
              <Select
                placeholder="Select AML Screening"
                optionFilterProp="children"
                style={{ height: "44px" }}
                options={amlScreeningOptions}
              />
            </Form.Item>
          </Col>

          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <Space>
                  Sanctions Screening
                  <Tooltip title="Select Sanctions Screening">
                    <InfoCircleOutlined />
                  </Tooltip>
                </Space>
              }
              name={"sanctionsScreening"}
              rules={[
                {
                  required: true,
                  message: "Please select sanction screening status",
                },
              ]}
            >
              <Select
                placeholder="Select Sanction Screeening"
                optionFilterProp="children"
                style={{ height: "44px" }}
                options={sanctionScreeningOptions}
              />
            </Form.Item>
          </Col>

          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <Space>
                  Central Bank Reporting Requirements
                  <Tooltip title="Central Bank Reporting Requirements">
                    <InfoCircleOutlined />
                  </Tooltip>
                </Space>
              }
              name={"centralBankReportingRequirements"}
              rules={[
                {
                  required: true,
                  message: "Please select central bank report status",
                },
              ]}
            >
              <Select
                placeholder="Select Central Bank Reporting Requirements"
                optionFilterProp="children"
                style={{ height: "44px" }}
                options={centralBankReportOptions}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default ComplianceChecks;
